import React, { useState, useRef, useCallback, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { FlexLayout, useQwanta } from 'qwanyx';

export const JSXEditor = ({ qwantumId = null, labelText = 'Label', name }) => {
  const [savedText, setQwanta] = useQwanta(qwantumId);
  const [jsxContent, setJsxContent] = useState(savedText || '');
  const [editorPosition, setEditorPosition] = useState({ top: 0, left: 0 });
  const editorRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (savedText) {
      setJsxContent(savedText);
    }
  }, [savedText]);

  // Calculate editor position on mount
  useEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setEditorPosition({
        top: rect.top,
        left: rect.left
      });
    }
  }, []);

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
  };

  const saveText = useCallback(() => {
    if (!qwantumId) return;
    setQwanta(qwantumId, jsxContent);
  }, [qwantumId, jsxContent, setQwanta]);

  const handleEditorChange = (value) => {
    setJsxContent(value || '');
  };

  const formatJSX = () => {
    if (editorRef.current) {
      editorRef.current.getAction('editor.action.formatDocument').run();
    }
  };

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden" // Prevent any overflow
      }}
    >
      <FlexLayout
        direction="row"
        width="100%"
        height="30px"
        aSize="100px"
        bSize="150px"
        aAlign='flex-start'
        aJustify='center'
        mAlign='center'
        mJustify='center'
        bAlign='flex-end'
        bJustify='center'
        a={
          <button onClick={formatJSX}>
            Format JSX
          </button>
        }
        m={
          <div className="componentTitle">
            {labelText}
          </div>
        }
        b={
          <button onClick={saveText}>
            Save
          </button>
        }
      />

      <div style={{
        height: `calc(100vh - ${editorPosition.top + 20}px)`, // 100vh - (top position + bottom padding don't know where it comes)
        maxWidth: `calc(100vw - ${editorPosition.left}px)`, // 100vw - (left position + parasite scroller that needs to be removed!!!)
        position: "relative"
      }}>
        <Editor
          name={name}
          height="100%"
          width="100%"
          language="javascript"
          value={jsxContent}
          onMount={handleEditorDidMount}
          onChange={handleEditorChange}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            automaticLayout: true,
            jsx: true
          }}
        />
      </div>
    </div>
  );
};

export default JSXEditor;